<script>
import { Input } from 'element-ui'
export default {
  name: 'PriceInput',
  functional: true,
  render(createElement, { data, props, children, slots }) {
    const { attrs, directives = [] } = data
    const { type: arg = 'price', limitlength = 8 } = props
    Object.assign(attrs, { limitlength })
    Object.assign(data, {
      directives: [
        ...directives,
        {
          name: 'priceInput',
          arg
        }
      ]
    })
    const slotsObj = slots()
    const childrenList = Object.keys(slotsObj).map(key => {
      const item = slotsObj[key][0]
      return createElement(item.tag, Object.assign({}, item.data, {slot: key}), item.children)
    })
    return createElement(Input, data, childrenList)
  }
}
</script>
